import React, { Component } from 'react';
import FAQArticle from '../../models/FAQArticle';
import Collapse from 'react-bootstrap/esm/Collapse';

type FAQArticleViewProps = {
    article: FAQArticle,
    id: string
}

type FAQArticleViewState = {
    isSelected: boolean
}

export default class FAQArticleView extends Component<FAQArticleViewProps, FAQArticleViewState> {
    constructor(props: FAQArticleViewProps) {
        super(props);
        this.state = {
            isSelected: false
        }
    }

    public toggleSelected() {
        this.setState({
            isSelected: !this.state.isSelected
        });
    }

    public render() {
        return (
            <React.Fragment>
                {
                    <div className={"accordeon-panel w-100 " + (this.state.isSelected ? " accordeon-panel-selected bg-white" : "")} >
                        <button
                            onClick={() => this.toggleSelected()}
                            aria-expanded={this.state.isSelected ? "true" : "false"}
                            aria-controls={this.props.id}
                            type="button"
                            className="w-100 p-3 d-flex justify-content-between btn-no-styling">
                            <span className="font-weight-bolder text-dark-blue p-0 m-0 text-left">{this.props.article.question} </span>
                            <span className={"icon icon-chevron icon-chevron-primary" + (this.state.isSelected ? " icon-chevron-up" : "")}></span>
                        </button>
                        <Collapse in={this.state.isSelected}>
                            <div id={this.props.id} className="text-left px-3 pb-3" dangerouslySetInnerHTML={{ __html: this.props.article.answer }}></div>
                        </Collapse>

                    </div>
                }
            </React.Fragment>
        );
    }
}